export class PopperConfig {
  static formsError = {
    boundariesElement: 'main',
    popperModifiers: {
      flip: {
        behavior: ['right', 'left', 'top-end', 'top-end']
      }
    },
    placement: 'right',
    applyClass: 'popper-opacity-danger',
    trigger: 'none',
    showTrigger: 'none',
    hideOnClickOutside: false,
    hideOnMouseLeave: false,
    appendTo: 'body'
  };

  static default = {
    boundariesElement: 'main',
    popperModifiers: {
      flip: {
        behavior: ['right', 'left', 'top', 'top']
      }
    },
    placement: 'right',
    applyClass: 'popper-opacity-secondary',
    trigger: 'hover',
    showTrigger: 'hover',
    hideOnClickOutside: false,
    hideOnMouseLeave: false,
    appendTo: 'body'
  };
}
